import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-error-circle-icon',
  templateUrl: './code-error-circle.component.html'
})
export class CodeErrorCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
